import React from 'react';
import {MasterLayout} from 'components/layouts';
import {MyBusinessPayments} from 'components/my-business';
import BusinessZone from 'pages/my-business/BusinessZone.jsx';
import title from 'constants/TitlePages.js';

class MyBusinessPaymentsPage extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.MyBusinessPaymentsPage;
  }

  render() {
    return (
      <MasterLayout>
        <MyBusinessPayments params={this.props.match.params}/>
      </MasterLayout>
    );
  }
}

export default MyBusinessPaymentsPage;



// WEBPACK FOOTER //
// ./pages/my-business/MyBusinessPaymentsPage.jsx